import '../../../../../node_modules/@lit/reactive-element/reactive-element.js';
import '../../../../../node_modules/lit-html/lit-html.js';
import '../../../../../node_modules/lit-element/lit-element.js';
import { css as i } from '../../../../../node_modules/@lit/reactive-element/css-tag.js';

var css_248z = i`.card-heading{-webkit-box-orient:vertical;-webkit-line-clamp:3;display:box;font-size:18px;font-weight:600;line-height:24px;margin:16px 0 8px;overflow:hidden}@media (max-width:767px){.card-heading.mobileWhite{color:#fff}}`;

export { css_248z as default };
